<template>
	 
	<div>

		<div class="w-100 account-header">
			<h2 class="mb-none">Email, Password &amp; Account</h2>
			<a class="action" v-if="user.hasPermission" @click.prevent="form = true"><i class="el-icon-edit float-right"></i></a>
			<em v-if="isViewingOwnProfile">Visible To You Only</em>
		</div>
		
		<hr class="solid mt-xs">

		<div class="form-group">
			<div class="row">
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Email</dt>
						<dd>{{user.email}}</dd>
					</dl>
				</div>
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Username</dt>
						<dd>{{user.email}}</dd>
					</dl>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6 col-xl-4">
					<dl>
						<dt>Password</dt>
						<dd>************</dd>
					</dl>
				</div>

				<div class="col-sm-6 col-xl-4">
					
				</div>


			</div>
		</div>

		<el-dialog title="Basic Info"
							 :visible.sync="form"
							 :width="modalWidth"
							 :close-on-click-modal="false"
							 :append-to-body="false"
							 custom-class="secure">


			<el-alert title="Changing your email address will also update your username to the same value. You can also optionally change your password."
								type="warning"
								effect="dark"
								show-icon
								:closable="false" class="mb-4" style="color: white !important">
			</el-alert>

			<!--<span class="el-icon-lock"></span>-->

			<div class="form row">
				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('email')}]">
					<label>Email/Username*</label>
					<el-input v-model="data.email" name="email" data-vv-as="email" class="w-100" v-validate="'required|email'" />
					<span v-if="errors.has('email')">{{errors.first('email')}}</span>
				</div>

			</div>

			<div class="form row">
				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('password')}]">
					<label>Password<span v-if="confirmRequired">*</span></label>
					<el-input type="password" @change="passwordConfirm = null" ref="password" name="password" v-model="data.password" data-vv-as="password" class="w-100" v-validate="{regex: /\S{7,20}$/}" />
					<password v-model="data.password" :strength-meter-only="true"></password>
					<span v-if="errors.has('password')">Must be at least 7 characters.</span>
				</div>
				<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('confirm password')}]">
					<label>Confirm Password<span v-if="confirmRequired">*</span></label>
					<el-input type="password" name="confirm password" v-model="passwordConfirm" data-vv-as="confirm password" class="w-100" v-validate="{ required: confirmRequired, confirmed: 'password' }" />
					<span style="word-break: break-word" v-if="errors.has('confirm password')">{{errors.first('confirm password')}}</span>

				</div>


			</div>

			<el-alert :title="serverError" v-if="serverError"
								type="error"
								effect="dark"
								show-icon
								:closable="false" class="mt-4">
			</el-alert>



			<span slot="footer" class="dialog-footer">
				<el-button :disabled="thinking.save" @click="form = false">Cancel</el-button>
				<el-button :loading="thinking.save" type="primary" @click="submit">Confirm</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import { rest } from "@/utilities/rest.js";
	import Password from 'vue-password-strength-meter'
import { mapGetters } from "vuex";
	export default {
		name: "account",
		data() {
			return {
				view: "template",
				form: false,
				data: {
					
				},

				passwordConfirm: null,

				serverError: null,

				suggestions: [],

				thinking: {
					save: false,
					visible: false
				}
			}
		},

		components: {
			Password
		},

		created() {
			this.data = JSON.parse(JSON.stringify(this.user));
			this.data.password = "";
			//this.data.passwordConfirm = "";
			
		},

		computed: {
			...mapGetters({
				modalWidth: "modalWidth"
			}),

			confirmRequired() {
				return this.data.password !== null && this.data.password !== undefined && this.data.password.length > 0;
			}
		},

		methods: {
			showFeedback({ suggestions, warning }) {
				this.suggestions = suggestions;
			},
			updateProfileVisibility(method) {

				let payload = {
					method: method,
					userId: this.user.userId
				};

				this.thinking.visible = true;
				rest.post("Account", "/UpdateProfileVisibility", "json", JSON.stringify(payload)).done(response => {
					setTimeout(() => {
						this.$message.success("Changes have been saved.");
					}, 1000);
					this.$emit("fetch", "account");
				}).always(() => {
					this.thinking.visible = false;
				});
			},

			submit() {
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.save = true;
						this.data.password = this.data.password || "";
						rest.post("Account", "/UpdateAccount", "json", JSON.stringify(this.data)).done(response => {
							this.form = false;
							setTimeout(() => {
								this.$message.success("Changes have been saved.");
							}, 1000);
							this.$emit("fetch", "account");
						}).fail((error) => {
							this.serverError = JSON.parse(error.responseText);
						}).always(() => {
							this.thinking.save = false;
						});
					}
				});
			}
		},

		props: ["user", "isViewingOwnProfile"],

		watch: {
			form(val) {
				if (val) {
					this.data = JSON.parse(JSON.stringify(this.user));
					//this.data.password = "";
					this.$validator.reset();
				}
			}
		}
	}
</script>

<style>
	.el-dialog.secure {
		overflow: hidden;
		z-index:1
	}
	.el-dialog.secure:before {
		content: "\E6E5";
    font-family: element-icons!important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    position: absolute;
    font-size: 600px;
    opacity: .04;
    right: -205px;
    bottom: -134px;
		z-index:-1;
	}
	

</style>